// extracted by mini-css-extract-plugin
export default {"iconWarning":"iconWarning__C9K271"};